import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { flightTourOptionPropTypes } from './PropTypes';

import {
  currencyDepositAndTotalPricePropTypes,
  getPricePerPaxTypePerCurrency,
} from '../../../util/currency';
import UpgradeCard from '../BookingFieldset/UpgradeCard';

const propTypes = exact({
  arrivalText: PropTypes.string,
  departureAirportText: PropTypes.string,
  currencyPriceSetting: currencyDepositAndTotalPricePropTypes,
  currencySymbol: PropTypes.string.isRequired,
  departureText: PropTypes.string,
  groupIndex: PropTypes.number.isRequired,
  handleOptionSelect: PropTypes.func.isRequired,
  limitedAvailabilityText: PropTypes.string,
  optionAddedText: PropTypes.string,
  options: PropTypes.arrayOf(flightTourOptionPropTypes).isRequired,
  selectedKey: PropTypes.string,
  soldOutText: PropTypes.string.isRequired,
  stopoverDataKey: PropTypes.string,
  perPersonText: PropTypes.string,
});

const defaultProps = {
  limitedAvailabilityText: '',
  optionAddedText: '',
  selectedKey: '',
  stopoverDataKey: '',
  perPersonText: 'pp',
};

function FlightGroup(props) {
  const {
    groupIndex,
    handleOptionSelect,
    stopoverDataKey,
    currencyPriceSetting,
    currencySymbol,
    perPersonText,
  } = props;

  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {props.options.map((flightTourOption) => {
          const currencyPriceSettingPrice = getPricePerPaxTypePerCurrency(
            flightTourOption.flightClasses[0].pricePerPax[0].pricePerCurrency,
            currencyPriceSetting.currency
          );
          return (
            <div className="UpgradeGroup_item" key={flightTourOption.key}>
              <UpgradeCard
                arrivalDate={flightTourOption.option.outboundArrivalDate}
                arrivalText={props.arrivalText}
                arrivalTime={flightTourOption.option.outboundArrivalTime}
                blockName="UpgradeGroup_card"
                currencySymbol={currencySymbol}
                departureAirport={flightTourOption.option.outboundDepartureAirport}
                departureAirportText={props.departureAirportText}
                departureDate={flightTourOption.option.outboundDepartureDate}
                departureText={props.departureText}
                departureTime={flightTourOption.option.outboundDepartureTime}
                description={flightTourOption.option.fullDescription}
                handleClick={() =>
                  handleOptionSelect(groupIndex, flightTourOption.option.key, stopoverDataKey)
                }
                isSelected={flightTourOption.option.key === props.selectedKey}
                limitedAvailability={flightTourOption.limitedAvailability}
                limitedAvailabilityRemainingSpaces={
                  flightTourOption.limitedAvailabilityRemainingSpaces
                }
                limitedAvailabilityRemainingText={flightTourOption.limitedAvailabilityText}
                limitedAvailabilityText={props.limitedAvailabilityText}
                price={currencyPriceSettingPrice}
                pricePerPerson
                perPersonText={perPersonText}
                selectedText={props.optionAddedText}
                soldOut={flightTourOption.soldOut}
                soldOutText={props.soldOutText}
                title={flightTourOption.option.title}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

FlightGroup.propTypes = propTypes;
FlightGroup.defaultProps = defaultProps;

export default FlightGroup;
